import {
  FeatureAction,
  FeatureName,
  UserPermissions,
} from '@interfaces/featurePermission';

/**
 * O recorte de produto por PERMISSÃO, e não por papel (§6.3).
 *
 * O seletor de produto é a segunda superfície de autorização do front, paralela e independente do
 * `getUserPermissions`: ele decide quais comunidades entram na lista, e fazia isso por papel — o que
 * exclui o colaborador por construção, porque `COLLABORATOR` não é papel de comissão.
 */
export type PermissionFilter = {
  feature: FeatureName;
  /**
   * A ação é OBRIGATÓRIA, e não dá para assumir `view` (§6.3.1).
   *
   * O grant é conjunto absoluto: nada garante que `view` acompanhe as outras ações. Um seletor de
   * formulário de escrita filtrado por `view` daria produto a quem só pode ver, e tiraria o produto
   * de quem pode criar sem ver — que é o caso de `SendToContacts`, um seletor dentro de um
   * formulário que submete `scheduleMessages:create`.
   */
  action: FeatureAction;
};

/** `delete` é o vocabulário canônico da ação; `canRemove` é o nome do flag na tela (§4). */
const FLAG_POR_ACAO: Record<FeatureAction, keyof UserPermissions> = {
  view: 'canView',
  create: 'canCreate',
  update: 'canUpdate',
  delete: 'canRemove',
  export: 'canExport',
};

export const permiteProduto = (
  getUserPermissions: (
    feature: FeatureName,
    productId: number,
  ) => UserPermissions,
  filtro: PermissionFilter,
  productId: number,
) =>
  Boolean(
    getUserPermissions(filtro.feature, productId)[FLAG_POR_ACAO[filtro.action]],
  );
